import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Validate loopMode
  if (!properties.loopMode) {
    errors.push({ key: 'loopMode', message: 'Loop mode is required' });
  }

  // Validate count for 'count' mode
  if (properties.loopMode === 'count') {
    if (!properties.count || properties.count < 1) {
      errors.push({ key: 'count', message: 'Count must be at least 1' });
    }
    if (properties.count > 1000) {
      errors.push({ key: 'count', message: 'Count cannot exceed 1000' });
    }
  }

  // Validate condition for 'while' mode
  if (properties.loopMode === 'while') {
    if (!properties.condition || properties.condition.trim() === '') {
      errors.push({ key: 'condition', message: 'Condition is required for while loop' });
    }
  }

  // Validate maxIterations
  if (properties.maxIterations) {
    if (properties.maxIterations < 1) {
      errors.push({ key: 'maxIterations', message: 'Max iterations must be at least 1' });
    }
    if (properties.maxIterations > 10000) {
      errors.push({ key: 'maxIterations', message: 'Max iterations cannot exceed 10000' });
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
